import { colorsTheme } from "./colors/colors";

export const defaultTheme = {
  colors: colorsTheme,
};
